/* eslint-disable @typescript-eslint/no-var-requires */
import { createStore, applyMiddleware, combineReducers } from 'redux'
import { HYDRATE, createWrapper } from 'next-redux-wrapper'
import thunkMiddleware from 'redux-thunk'
import { configureStore } from '@reduxjs/toolkit'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import auth from 'tennders-auth/stores/reducer'
import market from 'tennders-market/bin/stores/reducer'
import offer from 'tennders-market/offer/stores/reducer'
import data from './data/reducer'
import modal from './modal/reducer'
import prompt from './prompt/reducer'
import view from './view/reducer'
import socket from './socket/reducer'
import options from './options/reducer'
import map from '@/plugins/map/stores/reducer'

const bindMiddleware = (middleware) => {
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line global-require
    const { composeWithDevTools } = require('redux-devtools-extension')
    return composeWithDevTools(applyMiddleware(...middleware))
  }
  return applyMiddleware(...middleware)
}

const combinedReducer = combineReducers({
  auth,
  data,
  modal,
  prompt,
  view,
  socket,
  market,
  options,
  offer,
  map
})

const reducer = (state, action) => {
  if (action.type === HYDRATE) {
    const nextState = {
      ...state, // use previous state
      ...action.payload // apply delta from hydration
    }
    if (state.count.count) {
      nextState.count.count = state.count.count
    } // preserve count value on client side navigation
    return nextState
  }
  return combinedReducer(state, action)
}

const store = configureStore({ reducer })

// eslint-disable-next-line import/no-mutable-exports
export let globalStore = null
const makeStore = ({ isServer }) => {
  if (globalStore) {
    return globalStore
  }

  if (isServer) {
    // If it's on server side, create a store
    return createStore(combinedReducer, bindMiddleware([thunkMiddleware]))
  }
  // If it's on client side, create a store which will persist

  const persistConfig = {
    key: 'tennders-persist',
    whitelist: ['auth'], // only counter will be persisted, add other reducers if needed
    storage // if needed, use a safer storage
  }

  const persistedReducer = persistReducer(persistConfig, combinedReducer) // Create a new reducer with our existing reducer

  const store = createStore(
    persistedReducer,
    bindMiddleware([thunkMiddleware])
  ) // Creating the store again

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  // eslint-disable-next-line no-underscore-dangle
  store.__persistor = persistStore(store) // This creates a persistor object & push that persisted object to .__persistor, so that we can avail the persistability featur
  globalStore = store
  return store
}

export const getStoreInstance = () => {
  if (!globalStore) {
    makeStore({ isServer: false })
  }

  return globalStore
}
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export const wrapper = createWrapper(makeStore)

export type RootState = ReturnType<typeof store.getState>
